import React from 'react';

import type { OptionType, ValueContainerProps } from '@atlaskit/select';
import { components } from '@atlaskit/select';

import MultiValueContainerWithOverflow from './MultiValueContainerWithOverflow';

export const ValueContainerWithOverflowStyles = {
  justifyContent: `space-between`,
};

// Select "components" prop cannot be overriden with inline component
// It causes problems with focus because of component recreation on every render

export default function ValueContainerWithOverflow(
  props: ValueContainerProps<OptionType, boolean>
): JSX.Element {
  return props.isMulti ? (
    <MultiValueContainerWithOverflow {...props} optionsLimit={3} />
  ) : (
    <components.ValueContainer {...props} />
  );
}
